import React, { useEffect, useRef, useState } from 'react';
import { JSXIf } from '@framework-controls/jsxconditions';
import { strings } from 'src/localization';
import css from '../DesktopPane.module.scss';
import { ApptVeh, NewVehicle, VehicleStockPhoto } from 'src/models';
import classNames from 'classnames';
import VehicleModelImages from 'src/components/VehicleImages/VehicleModelImages';
import VehicleMakeImages from 'src/components/VehicleImages/VehicleMakeImages';

interface IProps {
    optionsSelected: NewVehicle;
    vehiclePhoto?: VehicleStockPhoto;
    selectedVehicle: ApptVeh;
    prevMileage: string;
    theme: string;
    Itype: string | undefined;
    TMNAMileage: number;
}

const PropertyDisplay = (props: IProps) => {
    const {optionsSelected} = props;
    const selectedVehicle = props.selectedVehicle;
    const [estMil, setEstMil] = useState('');
    const onLoad = useRef(true);
    let {makeCode, make, year, model, trim, estMileage} = optionsSelected;
    if (selectedVehicle?.make && !optionsSelected.make) {
        makeCode = selectedVehicle.makeCode;
        make = selectedVehicle.make;
        year = selectedVehicle.vehYr;
        model = selectedVehicle.model;
        trim = selectedVehicle.series;
        estMileage = estMil;
    }

    useEffect(() => {
        if (!onLoad.current){
            if (selectedVehicle.mileage < 0) {
                const updatedMileage = props.TMNAMileage > parseInt(props.prevMileage) ? props.TMNAMileage.toString() :
                    props.prevMileage;
                setEstMil(parseInt(updatedMileage).toLocaleString('en-US'));
            } else if (selectedVehicle.mileage === parseInt(props.prevMileage) && props.prevMileage === '0') {
                setEstMil('0');
            } else {
                setEstMil(selectedVehicle.mileage.toLocaleString('en-US'));
            }
        } else {
            onLoad.current = false;
            setEstMil('0');
        }
    }, [onLoad, selectedVehicle?.mileage, props.prevMileage, props.TMNAMileage]);

    const selectedProperties = classNames(
        css.selectedProperties,
        {
            [css.selectedPropertiesCS]: props.theme === 'colorSensitive',
        },
    );

    const vehicleDisplay = classNames(
        css.vehicleDisplay,
        {
            [css.vehicleDisplayCS]: props.theme === 'colorSensitive',
            [css.vehicleDisplayHonda]: props.theme === 'honda',
        },
    );
    let makeLit = make;
    // if (makeLit === 'Porsche') {
    //     makeLit = '';
    // }

    if (makeCode === '2I') {
        makeLit = 'Scion';
        make = 'Scion';
    }

    if (makeLit === 'Ford Canada') {
        makeLit = 'Ford';
    }

    if (makeLit === 'Chrysler Canada') {
        makeLit = 'Chrysler';
    }

    if (makeLit === 'Vw Canada') {
        makeLit = 'Volkswagen';
    }

    if (makeLit === 'Bmwi') {
        makeLit = 'BMW';
    }

    if (makeLit === 'Honda Mtc/pp/pe') {
        makeLit = 'Honda';
    }

    if (makeLit === 'Cummins Mid-canada') {
        makeLit = 'Cummins';
    }

    if (makeLit === 'Discover Canada') {
        makeLit = 'Discover';
    }

    const makeModelClassNames = classNames(
        css.makeModel,
        {
            [css.makeModelBuick]: props.theme === 'buick',
            [css.makeModelHonda]: props.theme === 'honda',
            [css.makeModelBMW]: props.theme === 'bmw',
            [css.makeModelFord]: props.theme === 'ford',
            [css.makeModelIN]: props.theme === 'infiniti',
            [css.makeModelMazda]: props.theme === 'mazda',
            [css.makeModelAcura]: props.theme === 'acura',
        },
    );

    return (
        <div className={selectedProperties} id='selectedProperties'>
            <JSXIf Condition={make === ''}>
                <div id='DisplaySelVeh'>{strings.DisplaySelVeh}</div>
            </JSXIf>
            <JSXIf Condition={make !== ''}>
                <div id='SelectedVehicle'>{strings.SelVehicle}</div>
            </JSXIf>
            <div className={vehicleDisplay} id='vehicleDisplay'>
                <JSXIf Condition={make !== '' && model === ''}>
                    <div id='makeImage' className={css.makeBlock}>
                        <VehicleMakeImages make={make} type='thumb' background='light' theme={props.theme} />
                    </div>
                    <div id='renderMake' className={makeModelClassNames}>
                        {makeLit}
                    </div>
                </JSXIf>
                <JSXIf Condition={make !== '' && model !== ''}>
                    {/* added a new type to differentiate the vehicle pic the customer has chosen vs the available options */}
                    <VehicleModelImages year={year} make={make} model={model} type='display' Itype={props?.Itype}/>
                    {/* <VehicleModelImages year={year} make={make} model={model} type='thumb' Itype={props?.Itype}/> */}
                    <div className={makeModelClassNames} id='renderMakeModel'>
                        {makeLit} {model ? '- ' + model : ''}
                    </div>
                </JSXIf>
                <JSXIf
                    Condition={
                        year !== '' &&
                        !selectedVehicle
                    }
                >
                    <span id='renderYearColor'>
                        {year}
                    </span>
                    <div id='renderTrim'>{trim}</div>
                </JSXIf>
                <JSXIf Condition={year !== ''}>
                    {trim && trim !== '' ? <span id='renderYearTrim'>{year} | {trim}</span> :
                        <div className={css.year} id='renderYear'>{year}</div>}
                </JSXIf>
                <JSXIf Condition={ !!estMileage && estMileage !== '0'}>
                    <span id='renderMileage'>
                        {estMileage ? estMileage + ' ' + strings.Miles : ''}
                    </span>
                </JSXIf>
            </div>
        </div>
    );
};

export default PropertyDisplay;